import {
  IPerformanceLimitsConfig,
  IPerformanceLimitsTabsConfig,
} from '@shared/interfaces/performance-limits.interface';
import { ICustomAthleteCategory } from '@shared/interfaces/sport-configuration-form-data.interface';

export interface RawTabData {
  key: string;
  id?: number;
  name: string;
  isCustom: boolean;
  values: IPerformanceLimitsTabsConfig;
}

export interface TabBuildResult {
  visible: RawTabData[];
  hiddenCustomEntries: Record<string, IPerformanceLimitsTabsConfig>;
}

const FIXED_TAB_KEYS = ['pro', 'amateur', 'recreational'] as const;

export function buildTabData(
  config: IPerformanceLimitsConfig,
  customAthleteCategoryList: ICustomAthleteCategory[]
): TabBuildResult {
  const fixedTabs: RawTabData[] = FIXED_TAB_KEYS.map((key) => ({
    key,
    name: key,
    isCustom: false,
    values: config.tabs[key],
  }));

  const customEntriesById = indexCustomEntriesById(config.custom_tab_object);
  const matchedKeys = new Set<string>();

  const customTabs: RawTabData[] = customAthleteCategoryList.map(({ name, value: id }) => {
    const match = customEntriesById.get(id);
    if (match) {
      matchedKeys.add(match.key);
      return { key: match.key, id, name, isCustom: true, values: match.entry };
    }
    return { key: name, id, name, isCustom: true, values: config.tabs.amateur };
  });

  const hiddenCustomEntries: Record<string, IPerformanceLimitsTabsConfig> = Object.fromEntries(
    Object.entries(config.custom_tab_object).filter(([key]) => !matchedKeys.has(key))
  ) as Record<string, IPerformanceLimitsTabsConfig>;

  return { visible: [...fixedTabs, ...customTabs], hiddenCustomEntries };
}

function indexCustomEntriesById(
  customTabObject: Record<string, IPerformanceLimitsTabsConfig>
): Map<number, { key: string; entry: IPerformanceLimitsTabsConfig }> {
  return new Map(
    Object.entries(customTabObject)
      .filter(([, entry]) => entry.id != null)
      .map(([key, entry]) => [entry.id as number, { key, entry }])
  );
}